import script from "/app/pages/Login.vue?type=script";
import { render } from "/app/pages/Login.vue?type=template";
script.render = render;
export default script;
